import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function ImageElement({ children, className, element, ...props }: PlateElementProps) {
	const url = element.url as string | undefined;

	return (
		<PlateElement {...props} element={element} className={cn("my-4", className)}>
			<div contentEditable={false}>
				{url ? (
					<img src={url} alt="" className="max-w-full rounded-md" draggable={false} />
				) : (
					<div className="flex h-32 items-center justify-center rounded-md border border-dashed text-muted-foreground">
						Image
					</div>
				)}
			</div>
			{children}
		</PlateElement>
	);
}
